import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { Form } from "react-bootstrap";
import { commonPostPutFormData } from "../../../redux/reducers/commonApiSlice";
import {
  addCustomerIntent,
  updateCustomerIntent,
} from "../../../data/ApiEndpoints";
import CommonHeadingNBtns from "../../common-components/CommonHeadingNBtns";

const CustIntentForm = ({
  userInfoData,
  closeModal,
  callFunction,
  isEdit,
  rowData,
}) => {
  const dispatch = useDispatch();
  const { postPutLoadingFormData } = useSelector((state) => state.common);

  const iniFormvalues = {
    intentName: isEdit ? rowData?.name : "",
    isActive: isEdit && rowData?.status === "active" ? true : false,
    // isNextFollowupRequired:
    //   isEdit && rowData?.next_followup_required === 1 ? true : false,
  };
  const [formValues, setFormValues] = useState(iniFormvalues);
  const [formErrors, setFormErrors] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);

  const onChangeInput = (e) => {
    const { name, value, type, checked } = e.target;
    setIsSubmit(false);

    setFormValues((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const onSubmit = () => {
    setFormErrors(validateFollowupForm(formValues));
    setIsSubmit(true);
  };

  function validateFollowupForm(formValues) {
    let errors = {};

    if (!formValues.intentName) {
      errors.intentName = "required!";
    }

    return errors;
  }

  const handleAdd = async (requestBody) => {
    const method = isEdit ? "PUT" : "POST";
    const endpoint = isEdit ? updateCustomerIntent : addCustomerIntent;
    const token = userInfoData?.token;

    setIsSubmit(false);

    try {
      const result = await dispatch(
        commonPostPutFormData({ method, endpoint, requestBody, token })
      );

      if (result?.payload?.status) {
        toast.success(result?.payload?.message || "Success!");
        closeModal();
        callFunction();
      } else {
        const errorMessage = result?.error?.message || result?.payload?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.error("Error making POST request:", error);
    }
  };

  useEffect(() => {
    if (isSubmit && Object.keys(formErrors)?.length === 0) {
      const userData = {
        name: formValues.intentName,
        status: formValues.isActive ? "active" : "inactive",
        // next_followup_required: formValues.isNextFollowupRequired ? 1 : 0,
      };

      const formData = new FormData();

      for (const key in userData) {
        if (userData.hasOwnProperty(key)) {
          formData.append(key, userData[key]);
        }
      }

      if (isEdit) {
        formData.append("uid", rowData?.uid);
      }

      handleAdd(formData);
    }
  }, [isSubmit, formErrors]);

  return (
    <div className="createNewCTOModalContainer mod-width-50p">
      <CommonHeadingNBtns
        title="Add Customer Intent"
        btnTxt={isEdit ? "Update" : "Submit"}
        onClose={closeModal}
        onClick={onSubmit}
        isLoading={postPutLoadingFormData}
      />

      <form className="formContainer">
        <div className="formInputsGrid twoGridSystem">
          <div className="formInputBox">
            <label htmlFor="intentName" className={`formInputLabel`}>
              Customer Intent Name <span className="required">*</span>
            </label>

            <input
              type="text"
              placeholder="Enter Intent Name"
              className={`formInput ${
                formErrors?.intentName ? "formError" : ""
              }`}
              name="intentName"
              value={formValues.intentName}
              onChange={onChangeInput}
            />
          </div>
        </div>

        <div className="formInputsGrid switchInputs">
          <div className="formInputBox formInputSwitchBox flex-start">
            <div
              className={`commonWrapper commonSwitchWrapper no-border ${
                formErrors?.isActive ? "formError" : ""
              }`}
            >
              <Form.Check
                type="switch"
                name="isActive"
                label={`${formValues.isActive ? "Active" : "Not Active"}`}
                checked={formValues.isActive}
                onChange={onChangeInput}
              />
            </div>


            {/* <div
              className={`commonWrapper commonSwitchWrapper no-border ${
                formErrors?.isNextFollowupRequired ? "formError" : ""
              }`}
            >
              <Form.Check
                type="switch"
                name="isNextFollowupRequired"
                label={`${
                  formValues.isNextFollowupRequired
                    ? "Next Follow-up Status Required"
                    : "Next Follow-up Status Not Required"
                }`}
                checked={formValues.isNextFollowupRequired}
                onChange={onChangeInput}
              />
            </div> */}
          </div>
        </div>
      </form>
    </div>
  );
};

export default CustIntentForm;
